import { registerIcon } from "@ui5/webcomponents-base/dist/asset-registries/Icons.js";

const name = "slim-arrow-down";
const pathData = "M420.5 187q11-12 23 0 5 5 5 11t-5 11l-165 165q-10 9-23 9t-22-9l-166-165q-5-5-5-11.5t5-11.5 11.5-5 11.5 5l160 160q5 6 11 0z";
const ltr = false;
const accData = null;
const collection = "SAP-icons";
const packageName = "@ui5/webcomponents-icons";

registerIcon(name, { pathData, ltr, collection, packageName });

export default "SAP-icons/slim-arrow-down";
export { pathData, ltr, accData };